import React from 'react'
import PropTypes from 'prop-types'
import { Input, RadioGroup, CurrencyInput } from 'components'
import { BOOLEAN_OPTIONS } from 'config'
import exact from 'prop-types-exact'
import classNames from 'classnames'
import VerifiedMark from './VerifiedMark'

const propTypes = {
  label: PropTypes.string.isRequired,
  applies: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  assetIndex: PropTypes.number.isRequired,
  questionIndex: PropTypes.number.isRequired,
  assetLabels: PropTypes.object,
  truvValidated: PropTypes.bool,
  amountOnly: PropTypes.bool,
}

const defaultProps = {
  amountOnly: false,
}

function AssetField({
  label,
  assetIndex,
  questionIndex,
  applies,
  truvValidated,
  assetLabels,
  amountOnly,
}) {
  // Derive expand/collapse directly from the Formik value passed as prop.
  // Do NOT use local useState — it only initialises once and gets out of
  // sync when Formik updates the value from outside (e.g. "No to All").
  const hasAsset = applies === true || applies === 'true'

  return (
    <>
      <div className={classNames('row', { 'bottom-border': !hasAsset })}>
        <div className="col-12">
          <RadioGroup
            name={`householdAssets[${assetIndex}].applies`}
            label={`${questionIndex + 1}. ${label}`}
            options={BOOLEAN_OPTIONS}
            required
          />
        </div>
      </div>

      {hasAsset && (
        <>
          {amountOnly ? (
            <div className="row bottom-border">
              <div className="col-6">
                <CurrencyInput
                  name={`householdAssets[${assetIndex}].amount`}
                  label={assetLabels?.amount || 'Amount'}
                  required
                />
              </div>
            </div>
          ) : (
            <>
              <div className="row">
                <div className="col-6">
                  <CurrencyInput
                    name={`householdAssets[${assetIndex}].amount`}
                    label={assetLabels?.amount || 'Amount'}
                    required
                  />
                </div>
                <div className="col-6">
                  <Input
                    name={`householdAssets[${assetIndex}].source`}
                    label={
                      <div className="verified-mark-wrapper">
                        {assetLabels?.source || 'Bank'}
                        {truvValidated && <VerifiedMark />}
                      </div>
                    }
                    required
                  />
                </div>
              </div>
              <div className="row bottom-border">
                <div className="col-6">
                  <CurrencyInput
                    name={`householdAssets[${assetIndex}].income`}
                    label={assetLabels?.income || 'Income Accrued'}
                    required
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  )
}

AssetField.propTypes = exact(propTypes)
AssetField.defaultProps = defaultProps

export default React.memo(AssetField)
